export default "__VITE_ASSET__BlT8PWBd__"